export default {
    path : "officebuilding-carrier-focus",
    name : "officebuilding-carrier-focus",
    meta : {
        title : "关注载体"
    },
    component: () => import('@/pages/officebuilding/focusCarrier/Index'),
    redirect: {
        name : "officebuilding-carrier-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-carrier-focus-whole',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-carrier-focus-recent',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-carrier-focus-atme',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-carrier-focus-meat',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-carrier-focus-reply',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-carrier-focus-search',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'update',
            name: 'officebuilding-carrier-focus-update',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/focuscarrier/index.js